import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { css } from 'glamor';
import { firebase } from '../../../firebase';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import backendUrl from '../../../constants/urls';
import { editProfessor, editCourse } from '../../../store/actions/cartActions';
import { encodeUser } from '../../../methods/api-calls';

const containerStyle = css({
  position: 'relative',
});

class EditProfessorModal extends Component {
  state = {
    modal: false,
    profilePicture: '',
    progress: 0,
    fullName: '',
    personDescription: '',
    linkedinLink: '',
    previewProfilePicture: null,
  };

  componentDidMount() {
    const { professor } = this.props;
    this.setState({
      ...professor,
      previewProfilePicture: professor.profilePicture,
    });
  }

  baseState = this.state;

  resetForm = () => {
    this.setState(this.baseState);
  };

  closeModal = () => {
    this.props.onClick(this.state.modal);
  };

  handleChangeHover = e => {
    if (e.target.files[0]) {
      let imageHover = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(imageHover);
      reader.onload = () => {
        this.setState({ previewProfilePicture: reader.result });
      };
      this.handleUploadHover(imageHover);
    }
  };

  handleUploadHover = imageHover => {
    const data = new FormData();
    if (imageHover) {
      const authHeader = encodeUser();

      data.append('productImageHover', imageHover, imageHover.name);
      axios
        .post(`${backendUrl}api/upload-hover`, data, {
          headers: {
            accept: 'application/json',
            'Accept-Language': 'en-US,en;q=0.8',
            'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
            ...authHeader,
          },
        })
        .then(response => {
          if (200 === response.status) {
            // If file size is larger than expected.
            if (response.data.error) {
              if ('LIMIT_FILE_SIZE' === response.data.error.code) {
                alert('Tamaño máximo: 20MB');
              } else {
                console.log(response.data);
                // If not the given file type
                // alert( response.data.error, 'red' );
              }
            } else {
              // Success
              let fileName = response.data;
              this.setState({
                profilePicture: fileName.location,
              });
              // console.log( 'fileName', fileName.location );
              // alert( 'File Uploaded', '#3089cf' );
            }
          }
        })
        .catch(error => {
          // If another error
          alert(error);
        });
    } else {
      // if file not selected throw error
      alert('Please upload file');
    }
  };

  parseToBoolean = val => {
    if (typeof val === 'boolean') {
      return Boolean(val);
    } else if (val == 'true') {
      return Boolean(true);
    } else {
      return Boolean(false);
    }
  };

  editProfessor = e => {
    e.preventDefault();
    let { profilePicture, fullName, personDescription, linkedinLink, id } = this.state;

    const professor = {
      profilePicture: profilePicture,
      fullName: fullName,
      personDescription: personDescription,
      linkedinLink: linkedinLink,
    };

    if (fullName != '' && personDescription != '') {
      const db = firebase.firestore();
      const dbOrderRef = db.collection('professors');
      dbOrderRef
        .doc(id)
        .update(professor)
        .then(() => {
          this.props.editProfessor(professor);

          const { courses } = this.props;

          let coursesToUpdate = [];

          courses.forEach(c => {
            if (c.professor.id == id) {
              coursesToUpdate.push(c);
            }
          });

          if (coursesToUpdate && coursesToUpdate.length > 0) {
            coursesToUpdate.forEach(course => {
              const newCourse = { ...course };
              newCourse.professor = professor;
              newCourse.professor.id = id;

              const courseId = course.id;
              const db = firebase.firestore();
              const dbOrderRef = db.collection('courses');
              dbOrderRef
                .doc(courseId)
                .update(newCourse)
                .then(() => {
                  this.props.editCourse(newCourse);
                });
            });
          }

          toast.success('Profesor fue editado exitosamente.', {
            position: 'bottom-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setTimeout(() => {
            window.location.reload();
          }, 3000);
          this.closeModal();
          this.resetForm();
        });
    } else {
      toast.error('Rellene los campos', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  render() {
    let { previewProfilePicture } = this.state;
    return (
      <React.Fragment>
        <div className={`admin-product-modal ${this.props.active}`}>
          <ToastContainer className={containerStyle} />
          <div className="modal-innter-content">
            <button type="button" className="close" onClick={this.closeModal}>
              <span aria-hidden="true">
                <i className="bx bx-x"></i>
              </span>
            </button>

            <div className="modal-body">
              <h3>Editar Profesor</h3>

              <form onSubmit={this.editProfessor}>
                <div className="form-group">
                  <label>Subir la imagen de perfil aquí</label>
                  <p>*Nota: Si subes una imagen se sustituirá la anterior.</p>
                  <div className="upload-img">
                    <span>
                      <i className="bx bxs-image-add"></i>
                      Seleccionar
                    </span>

                    <input
                      type="file"
                      className="form-control-file"
                      name="productImageHover"
                      onChange={this.handleChangeHover}
                    />
                  </div>

                  {previewProfilePicture ? (
                    <div className="uploaded-img">
                      <img src={previewProfilePicture} alt="Image" className="img-thumbnail" />
                    </div>
                  ) : null}
                </div>

                <h4 className="title title-underline">Agrega información del profesor aquí</h4>

                <div className="form-group">
                  <label>Nombre completo</label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.fullName}
                    onChange={e => this.setState({ fullName: e.target.value })}
                  />
                </div>

                <div className="form-group">
                  <label>Descripción completa de la persona (estudios, etc)</label>
                  <textarea
                    className="form-control content-paragraph"
                    value={this.state.personDescription}
                    onChange={e => this.setState({ personDescription: e.target.value })}
                    rows="3"
                  />
                </div>

                <div className="form-group">
                  <label>
                    Link al perfil de linkedin (ej:
                    https://www.linkedin.com/in/juan-gomez-bb6874153/)
                  </label>
                  <input
                    className="form-control"
                    value={this.state.linkedinLink}
                    onChange={e => this.setState({ linkedinLink: e.target.value })}
                    rows="3"
                  />
                </div>

                <div className="modal-btn">
                  <div className="btn optional-btn float-left" onClick={this.closeModal}>
                    Cancelar
                  </div>
                  <button className="btn default-btn float-right">Editar profesor</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    courses: state.courses,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    editProfessor: professor => {
      dispatch(editProfessor(professor));
    },
    editCourse: course => {
      dispatch(editCourse(course));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EditProfessorModal));
